import React from 'react';
import { motion } from 'framer-motion';
import { FaInbox, FaHeart, FaEnvelopeOpen, FaUserFriends, FaThumbtack, FaArchive } from 'react-icons/fa';

const filters = [
  { id: 'all', label: 'Tous', icon: FaInbox, count: null },
  { id: 'favorites', label: 'Favoris', icon: FaHeart, count: null },
  { id: 'unread', label: 'Non lus', icon: FaEnvelopeOpen, count: null },
  { id: 'matches', label: 'Matchs', icon: FaUserFriends, count: null },
  { id: 'pinned', label: 'Épinglés', icon: FaThumbtack, count: null },
  { id: 'archived', label: 'Archivés', icon: FaArchive, count: null },
];

const FilterTabs = ({ activeFilter, onFilterChange, counts = {} }) => {
  return (
    <div className="filter-tabs">
      {filters.map((filter) => {
        const Icon = filter.icon;
        const isActive = activeFilter === filter.id;
        const count = counts[filter.id] || 0;
        
        return (
          <motion.button
            key={filter.id}
            className={`filter-tab ${isActive ? 'active' : ''}`}
            onClick={() => onFilterChange(filter.id)}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Icon className="filter-icon" />
            <span className="filter-label">{filter.label}</span>
            {count > 0 && (
              <motion.span 
                className="filter-count"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: "spring", stiffness: 500, damping: 25 }}
              >
                {count}
              </motion.span>
            )}
            {isActive && (
              <motion.div
                className="filter-indicator"
                layoutId="activeFilter"
                transition={{ type: "spring", stiffness: 500, damping: 30 }}
              />
            )}
          </motion.button>
        );
      })}
    </div>
  );
};

export default FilterTabs;
